module.exports = __webpack_public_path__ + "static/media/login-screen-image.63820be4.svg";